var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2586 5.7998H17.069C18.1355 5.7998 19 6.60168 19 7.59085V19.0088C19 19.9979 18.1355 20.7998 17.069 20.7998H6.93103C5.86455 20.7998 5 19.9979 5 19.0088V7.59085C5 6.60168 5.86455 5.7998 6.93103 5.7998H8.74138",
    stroke: "#5D5D5D",
    strokeWidth: 1.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.91895 4.40695C8.85525 3.81568 9.3185 3.2998 9.9132 3.2998H13.9361C14.5308 3.2998 14.9941 3.81568 14.9304 4.40695L14.7148 6.40695C14.6601 6.91483 14.2314 7.2998 13.7206 7.2998H10.1287C9.6179 7.2998 9.1892 6.91483 9.13448 6.40695L8.91895 4.40695Z",
    stroke: "#5D5D5D",
    strokeWidth: 1.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.0498 13.2894C9.70098 13.9138 11.0312 15.1895 11.1428 15.2966C11.2545 15.4036 13.794 12.8433 15.0498 11.5498",
    stroke: "#5D5D5D",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTask);
export default __webpack_public_path__ + "static/media/Task.b17c6c543f95ce3a37cf8b7749b64409.svg";
export { ForwardRef as ReactComponent };